export { ExcludedCompartmentPathways } from './ExcludedCompartmentPathways.component';
